import isEmpty from "lodash/isEmpty";
import {
  API_BASE_URL_DEV,
  API_BASE_URL_PROD,
  LOCAL_STORAGE_USER_DATA_NAME,
  API_BASE_URL_STG,
} from "../constants";

export const setQueryParams = (params) => {
  const _params = [];
  let combinedQuery = "";
  if (isEmpty(params)) return "";

  Object.keys(params).forEach(function (key, value) {
    if (Array.isArray(params[key]) && params[key].length > 0) {
      combinedQuery = combinedQuery + setRepeatedParams(key, params[key]);
    } else if (params[key] !== "" && !Array.isArray(params[key])) {
      _params[key] = params[key];
    }
  });

  const query = Object.keys(_params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");
  return combinedQuery ? `?${query}&${combinedQuery}` : `?${query}`;
};

export const setRepeatedParams = (key, valueArr) => {
  if (isEmpty(valueArr)) return "";
  const query = valueArr
    .map((k) => `${encodeURIComponent(key)}=${encodeURIComponent(k)}`)
    .join("&");
  return `${query}`;
};

export const getApiUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case "prod":
      return API_BASE_URL_PROD;
    case "stage":
      return API_BASE_URL_STG;
    default:
      return API_BASE_URL_DEV;
  }
};

export const getAuthToken = () => {
  const adminData = localStorage.getItem(LOCAL_STORAGE_USER_DATA_NAME);
  const user = adminData ? JSON.parse(adminData) : {};
  return user.accessToken || "";
};

export const getUserData = () => {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA_NAME));
};

export const handleTokenExpiry = (data) => {
  if (
    data.statusCode === 401 &&
    window.location.pathname !== "/login" &&
    window.location.pathname !== "/register"
  ) {
    localStorage.clear();
    window.location.reload();
  }
};

export const downloadFile = (url, fileName, errCallback) => {
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = fileUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(fileUrl);
    })
    .catch(errCallback);
};
